import { AdContainer } from '../ad-container/ad-container';
import { CreativeTagEvent } from '../enums';
import { EventEmitter } from '../types';

export class AdContainerUnloadHandler {
  constructor(
    protected readonly eventSource: EventEmitter<CreativeTagEvent>,
    protected readonly adContainer: AdContainer
  ) {
    this.attachEventHandlers();
  }

  private attachEventHandlers() {
    this.eventSource.addEventListener(
      CreativeTagEvent.CreativeLoadingFailed,
      this.handleUnload.bind(this)
    );
  }

  private handleUnload() {
    // Handle the unload event
    this.adContainer.unload();
  }
}
